import { Box } from "@mui/material";
import { FC, useState } from "react";
import "swiper/css";
import {
  SignInHeader,
  SignInSlider,
  SignInWrapper,
} from "../../../features/auth";

export const SignIn: FC = () => {
  const [isBlur, setIsBlur] = useState(false);
  const handleBlur = (isFocus: boolean) => setIsBlur(isFocus);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        py: 4,
      }}
    >
      <SignInHeader />
      <SignInSlider isBlur={isBlur} />
      <SignInWrapper handleFocus={handleBlur} />
    </Box>
  );
};
